import { MatDialogRef } from '@angular/material/dialog';

import { TemplateRef } from '@angular/core';
import { environment } from 'environments/environment';
import { DialogService } from '../components/dialog/service/dialog.service';
import { SimpleDialogComponent } from '../components/dialog/simple-dialog/simple-dialog.component';

export class MessageBox {
    static show(
        message,
        title = 'Alert',
        information = '',
        button = 0,
        allowOutsideClick = false,
        style = 0,
        width = '200px',
        subInformation = '',
        captions: string[] = [],
        template: TemplateRef<any> = null
    ): MatDialogRef<SimpleDialogComponent, any> {
        const dialogService = environment.injector.get(DialogService);
        const dialogRef = dialogService.open(SimpleDialogComponent, {
            data: {
                title: title || 'Alert',
                message: message,
                information: information,
                button: button || 0,
                style: style || 0,
                allowOutsideClick: allowOutsideClick || false,
                subInformation: subInformation,
                captions: captions,
                template,
            },
            width: width,
            hasBackdrop: true,
            maxWidth: 'none',
        });
        return dialogRef;
    }
}

export const MessageBoxButton = {
    Ok: 0,
    OkCancel: 1,
    YesNo: 2,
    AcceptReject: 3,
    YesNoCancel: 4,
} as const;

export type MessageBoxButton = (typeof MessageBoxButton)[keyof typeof MessageBoxButton];

export const MessageBoxStyle = {
    Simple: 0,
    Full: 1,
    Warning: 2,
    Information: 3,
    Failure: 4,
    Success: 5,
    Question: 6,
} as const;

export type MessageBoxStyle = (typeof MessageBoxStyle)[keyof typeof MessageBoxStyle];
